var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"ylNewsList"}},[(_vm.isMobileScreen)?_c('ylNewsListMobile',_vm._b({},'ylNewsListMobile',_vm.$attrs,false)):_c('ylNewsListPC',_vm._b({},'ylNewsListPC',_vm.$attrs,false))],1)
}
var staticRenderFns = []

export { render, staticRenderFns }